const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category collection component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('themeSettings', [
  'Application',
  'Companies',
  function (Application, Companies) {
    return {
      restrict: 'E',
      scope: {},
      template: require('../../templates/directives/theme-settings.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;

          self.selectCard = async function(type) {
            if (type === self.themeSelection || (type !== 'card' && type !== 'list')) {
              return;
            }

            try {
              const results = await Companies.setTheme({type}).$promise;
              if (results.status !== 'success') {
                Application.messaging.addMessage({status: 'error', duration: 6, text: 'There was an error in updating theme settings.'});
                $scope.$apply();
                return;
              }

              self.themeSelection = type;
              Application.messaging.addMessage({status: 'success', duration: 8, text: 'Theme settings updated! Users need to logout and back in for changes to take effect.'});
            } catch (error) {
              Application.messaging.addMessage({status: 'error', duration: 6, text: 'There was an error in updating theme settings.'});
            }

            $scope.$apply();

          }

          self.init = async function () {
            const company = await Companies.get().$promise;
            self.themeSelection = company.feature_flags.explore_in_list_view ? 'list' : 'card';
            $scope.$apply();
          };

          self.init();
        },
      ],
      controllerAs: 'settings',
    };
  },
]);
